import { MbscModule, momentTimezone } from '@mobiscroll/angular';
import { ComponentsModule } from './components/commoncomponents/components.module';
import { CommonLayoutModule } from './components/commonlayouts/common-layout/common-layout.module';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClientJsonpModule,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { AuthenticationService } from './services/authentication.service';
import { AuthGuard } from './services/auth.guard';
import { AuthInterceptor } from './services/auth.interceptor';
import { AppointmentService } from './services/appointment.service';
import { CommonLayoutComponent } from './components/commonlayouts/common-layout/common-layout.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BackgroundFormComponent } from './components/background-form/background-form.component';
import { DiagnosticiansComponent } from './components/diagnosticians/diagnosticians.component';
import { DirectorsComponent } from './components/directors/directors.component';
import { CreateUserComponent } from './components/create-user/create-user.component';
import { CancelledAppointmentComponent } from './components/cancelled-appointment/cancelled-appointment.component';
import { CompletedAppointmentsComponent } from './components/completed-appointments/completed-appointments.component';
import { AvailabilityComponent } from './components/availability/availability.component';
import { CreateAppointmentComponent } from './components/create-appointment/create-appointment.component';
import { AdminBackgroundFormsComponent } from './components/admin-background-forms/admin-background-forms.component';
import { ViewAllComponent } from './components/view-all/view-all.component';
import { ClientAppointmentDetailComponent } from './components/client-appointment-detail/client-appointment-detail.component';
import { FollowUpComponent } from './components/follow-up/follow-up.component';
import { StudentObservationComponent } from './components/student-observation/student-observation.component';
import { AppointmentAllDetailsComponent } from './components/appointment-all-details/appointment-all-details.component';
import { AdminViewStudentObservationComponent } from './components/admin-view-student-observation/admin-view-student-observation.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { AdminsComponent } from './components/admins/admins.component';
import { CreateAdminUserComponent } from './components/create-admin-user/create-admin-user.component';
import { BackgroundFormAdultComponent } from './components/background-form-adult/background-form-adult.component';
import { AdminBackgroundFormAdultComponent } from './components/admin-background-form-adult/admin-background-form-adult.component';
import { TodaysAppointmentComponent } from './components/todays-appointment/todays-appointment.component';
import { AdminReviewCompletedComponent } from './components/admin-review-completed/admin-review-completed.component';
import { UpcomingAppointmentComponent } from './upcoming-appointment/upcoming-appointment.component';
import { InprogressAppointmentComponent } from './inprogress-appointment/inprogress-appointment.component';
import { InputMaskModule } from 'primeng/inputmask';
import { CalendarModule } from 'primeng/calendar';
import { RescheduleAppointmentsComponent } from './components/reschedule-appointments/reschedule-appointments.component';
import { RescheduleFollowUpComponent } from './components/reschedule-follow-up/reschedule-follow-up.component';
import { ReassignComponent } from './components/reassign/reassign.component';
import { DiagAvailabiltyComponent } from './components/diag-availabilty/diag-availabilty.component';
import { DatePipe } from '@angular/common';
import { HoldReportComponent } from './components/hold-report/hold-report.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ViewAllV2Component } from './components/view-all-v2/view-all-v2.component';
import { DataTablesModule } from 'angular-datatables';
import { UpcomingAppointmentV2Component } from './upcoming-appointment-v2/upcoming-appointment-v2.component';
import { InprogressAppointmentV2Component } from './inprogress-appointment-v2/inprogress-appointment-v2.component';
import { CompletedAppointmentsV2Component } from './components/completed-appointments-v2/completed-appointments-v2.component';
import { CancelledAppointmentsV2Component } from './components/cancelled-appointments-v2/cancelled-appointments-v2.component';
import { HoldReportV2Component } from './components/hold-report-v2/hold-report-v2.component';
import { PaymentsV2Component } from './components/payments-v2/payments-v2.component';
import { AdminsV2Component } from './components/admins-v2/admins-v2.component';
import { DiagnosticiansV2Component } from './components/diagnosticians-v2/diagnosticians-v2.component';
import { DirectorsV2Component } from './components/directors-v2/directors-v2.component';
import { AppAppointmentAllDetailsV2Component } from './components/app-appointment-all-details-v2/app-appointment-all-details-v2.component';
import { AbbreviatedMonthDatePipe } from './abbreviatedDate.pipe';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { NgChartsModule } from 'ng2-charts';

@NgModule({
  declarations: [
    AbbreviatedMonthDatePipe,
    AppComponent,
    LoginComponent,
    CreateAppointmentComponent,
    CommonLayoutComponent,
    BackgroundFormComponent,
    DiagnosticiansComponent,
    DirectorsComponent,
    CreateUserComponent,
    CancelledAppointmentComponent,
    CompletedAppointmentsComponent,
    AvailabilityComponent,
    AdminBackgroundFormsComponent,
    ViewAllComponent,
    ClientAppointmentDetailComponent,
    FollowUpComponent,
    StudentObservationComponent,
    AppointmentAllDetailsComponent,
    AdminViewStudentObservationComponent,
    PaymentsComponent,
    AdminsComponent,
    CreateAdminUserComponent,
    BackgroundFormAdultComponent,
    AdminBackgroundFormAdultComponent,
    TodaysAppointmentComponent,
    AdminReviewCompletedComponent,
    UpcomingAppointmentComponent,
    InprogressAppointmentComponent,
    RescheduleAppointmentsComponent,
    RescheduleFollowUpComponent,
    ReassignComponent,
    DiagAvailabiltyComponent,
    HoldReportComponent,
    ViewAllV2Component,

    UpcomingAppointmentV2Component,
    InprogressAppointmentV2Component,
    CompletedAppointmentsV2Component,
    CancelledAppointmentsV2Component,
    HoldReportV2Component,
    PaymentsV2Component,
    AdminsV2Component,
    DiagnosticiansV2Component,
    DirectorsV2Component,
    AppAppointmentAllDetailsV2Component,
    AnalyticsComponent,
  ],
  imports: [
    MbscModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonLayoutModule,
    ComponentsModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    HttpClientJsonpModule,
    InputMaskModule,
    CalendarModule,
    MatSnackBarModule,
    DataTablesModule,
    NgChartsModule,
  ],
  providers: [
    AppointmentService,
    DatePipe,
    AuthenticationService,
    AuthGuard,
    [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }],
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
